import { HTTPError } from "ky";

import { HttpError } from "./errors";
import { getApiErrorMessage, parseHttpBody } from "./response";

function parseErrorBody(body: unknown): unknown {
  if (typeof body !== "string") return body;
  if (!body.trim()) return body;
  try {
    return parseHttpBody(body);
  } catch {
    return body;
  }
}

/**
 * Ky 2 fills `HTTPError.data` and consumes `error.response` before `beforeError`.
 * Cloning that response throws `Response body is already used`.
 */
export async function mapKyHttpError(error: Error): Promise<Error> {
  if (!(error instanceof HTTPError)) return error;

  const fromData = "data" in error ? error.data : undefined;
  let body: unknown = fromData;

  if (body === undefined && !error.response.bodyUsed) {
    try {
      body = await error.response.text();
    } catch {
      body = undefined;
    }
  }

  body = parseErrorBody(body);
  return new HttpError(getApiErrorMessage(body, error.message), {
    status: error.response.status,
    body,
    cause: error,
  });
}
